import StaffItem from './StaffItem';
import { StaffItemProps, StaffItemValueProps } from './types';

export type { StaffItemProps, StaffItemValueProps };
export default StaffItem;
